<h3 mat-dialog-title>Generated Report</h3>
<mat-dialog-content>
  <iframe
    width="100%"
    height="100%"
    [src]="source"
    frameborder="0"
    allowfullscreen="false"
    style="height: 73.77vh"></iframe>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
